/* The @parrot/ui Table provides header/row states, sort styling and the scroll
   shadow. We only add leaderboard-specific chrome: a comfortable fixed row
   height and the header help-icon affordance. */

.table {
  min-width: 1180px;
  table-layout: fixed;
}

/* Header label + help icon sit inline. */
.headCell {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  max-width: 100%;
}

.helpIcon {
  color: var(--text-disabled);
  flex-shrink: 0;
  transition: color var(--duration-fast) var(--ease-default);
}

.headCell:hover .helpIcon {
  color: var(--text-secondary);
}

/* Tooltip body: the tooltip div is a DOM descendant of the uppercase, nowrap
   header cell, so its text inherits those. Reset here so help copy reads as
   normal sentence-case prose that wraps inside the bubble's max-width. */
.tipBody {
  display: block;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  white-space: normal;
}

.tipTitle {
  display: block;
  text-align: left;
}

/* Fixed row height keeps every magnitude bar and value on one baseline, as the
   previous table did. Applied to the cells (the row is a <tr>). */
.cell {
  height: 60px;
  vertical-align: middle;
  font-size: var(--text-base);
  color: var(--text-primary);
  /* table-layout:fixed + the Td's explicit width clips overflow; no max-width:0 needed —
     that was clipping block children (the split bar) to zero. */
  overflow: hidden;
}

/* Whole sorted column tinted gold — the full-column highlight the old table had
   (in crimson), now in the active-gold language to match the sorted header.
   Row hover still layers over this. */
.cellActive {
  background: color-mix(in srgb, var(--active) 7%, transparent);
}

/* Loading placeholder for a media (icon/poster + name) column — the icon circle
   and the name bar side by side, so the skeleton reads as a row of real content
   rather than a flat bar. */
.skeletonMedia {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
}

/* Unsorted headers keep their sort chevrons hidden until hovered/focused, so the
   active column's indicator is the only one competing for attention. The sort
   icon is the button's direct <svg> child (the help icon is nested deeper). */
.table th:not([aria-sort]) button > svg {
  opacity: 0;
  transition: opacity var(--duration-fast) var(--ease-default);
}
.table th:not([aria-sort]) button:hover > svg,
.table th:not([aria-sort]) button:focus-visible > svg {
  opacity: 0.6;
}
